"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _quizz = require("./contexts/quizz");

var _speedometerMain = _interopRequireDefault(require("./viz/speedometer-main"));

var _simpleBarMain = _interopRequireDefault(require("./viz/simple-bar-main"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var QuizzViewer = function QuizzViewer(props) {
  var mainComponent = props.mainComponent,
      propsMainComponent = props.propsMainComponent,
      propsChildsComponent = props.propsChildsComponent; // on omet la 2eme entrée de l'array qui correspond à dispatch, inutilisé ici

  var _useContext = (0, _react.useContext)(_quizz.QuizzContext),
      _useContext2 = _slicedToArray(_useContext, 3),
      state = _useContext2[0],
      api = _useContext2[2];

  var _useContext3 = (0, _react.useContext)(_quizz.ConfigContext),
      _useContext4 = _slicedToArray(_useContext3, 1),
      config = _useContext4[0];

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      scores = _useState2[0],
      setScores = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      totalMax = _useState4[0],
      setTotalMax = _useState4[1];

  var memoGetPartiesScoreArray = api.memoGetPartiesScoreArray;
  (0, _react.useEffect)(function () {
    if (state.completed && state.currentQuestionnaireID !== "" && state.currentQuestionnaireID === config.questionnaire.id) {
      var _memoGetPartiesScoreA = memoGetPartiesScoreArray(),
          _memoGetPartiesScoreA2 = _slicedToArray(_memoGetPartiesScoreA, 2),
          computed_scores = _memoGetPartiesScoreA2[0],
          computed_totalMax = _memoGetPartiesScoreA2[1];

      setScores(computed_scores);
      setTotalMax(computed_totalMax);
    }
  }, [state.completed, config.questionnaire.id, state.currentQuestionnaireID, memoGetPartiesScoreArray]);

  var renderViz = function renderViz(main) {
    switch (main) {
      case "speedometer":
        return _react["default"].createElement(_speedometerMain["default"], {
          scores: scores,
          globalScore: state.globalScore,
          totalMax: totalMax,
          evaluations: config.questionnaire.evaluations,
          completed: state.completed,
          defaultSegmentColors: config.defaultSegmentColors,
          large: true,
          propsMainComponent: propsMainComponent || {},
          propsChildsComponent: propsChildsComponent || {}
        });

      case "simple-bar":
      default:
        return _react["default"].createElement(_simpleBarMain["default"], {
          scores: scores,
          globalScore: state.globalScore,
          totalMax: totalMax,
          evaluations: config.questionnaire.evaluations,
          completed: state.completed,
          defaultSegmentColors: config.defaultSegmentColors,
          propsMainComponent: propsMainComponent || {}
        });
    }
  };

  return _react["default"].createElement(_react["default"].Fragment, null, renderViz(mainComponent));
};

var _default = QuizzViewer;
exports["default"] = _default;